import type { AdvertiserDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';

import { formatIndustryOptionLabel } from 'src/hooks/useIndustryLocalizedOptions.ts';
import type { Option } from 'src/types.ts';

export const selectedFilterOptions = <T>(allOptions: Option<T>[], selectedIds?: T[]): Option<T>[] =>
  selectedIds ? allOptions.filter((option) => selectedIds.includes(option.value)) : [];

export const formatSelfBookingAdvertiserOptionLabel = (advertiser: AdvertiserDto, language: string) =>
  `${advertiser.name} (${formatIndustryOptionLabel(advertiser.industry, language)})`;
